import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IMiscellaneousFormMeta {
  // Dates
  terminalTransactionDateTime: FormInputMeta;
  transmissionDateTime: FormInputMeta;
  settlementDate: FormInputMeta;
  captureDate: FormInputMeta;
  // Cut-off
  systemCutOff: FormInputMeta;
  acquirerCutOff: FormInputMeta;
  issuerCutOff: FormInputMeta;
  // Countries
  receivingInstitutionCountry: FormInputMeta;
  settlementInstitutionCountry: FormInputMeta;
  forwardingInstitutionCountry: FormInputMeta;
  acquirerInstitutionCountry: FormInputMeta;
  // Institution Id
  receivingInstitutionId: FormInputMeta;
  settlementInstitutionId: FormInputMeta;
  forwardingInstitutionId: FormInputMeta;
  acquirerInstitutionId: FormInputMeta;
  // Others
  fieldNumber: FormInputMeta;
  messageText: FormInputMeta;
  acquirerDate: FormInputMeta;
  accountIdentification1: FormInputMeta;
  accountIdentification2: FormInputMeta;
  primaryRoutine: FormInputMeta;
  secondaryRoutine: FormInputMeta;


  schema: any;
}

const MiscellaneousFormMeta = {} as IMiscellaneousFormMeta;

// Dates
MiscellaneousFormMeta.terminalTransactionDateTime = {
  name: 'terminalTransactionDateTime',
  type: 'text',
  label: 'Date & heure de transaction du terminal',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
MiscellaneousFormMeta.transmissionDateTime = {
  name: 'transmissionDateTime',
  type: 'text',
  label: 'Date & heure de transmission ',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
MiscellaneousFormMeta.settlementDate = {
  name: 'settlementDate',
  type: 'text',
  label: 'date de règlement',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
MiscellaneousFormMeta.captureDate = {
  name: 'captureDate',
  type: 'text',
  label: 'Date de capture',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},

// Cut-off
MiscellaneousFormMeta.systemCutOff = {
  name: 'systemCutOff',
  type: 'text',
  label: 'Système suspension',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
MiscellaneousFormMeta.acquirerCutOff = {
  name: 'acquirerCutOff',
  type: 'text',
  label: 'Acquéreur suspension',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
MiscellaneousFormMeta.issuerCutOff = {
  name: 'issuerCutOff',
  type: 'text',
  label: 'Emetteur suspension',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},

// Countries
MiscellaneousFormMeta.receivingInstitutionCountry = {
  name: 'receivingInstitutionCountry',
  type: 'text',
  label: 'Pays de l\'institution destinataire',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
MiscellaneousFormMeta.settlementInstitutionCountry = {
  name: 'settlementInstitutionCountry',
  type: 'text',
  label: 'Pays institution de règlement',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
MiscellaneousFormMeta.forwardingInstitutionCountry = {
  name: 'forwardingInstitutionCountry',
  type: 'text',
  label: 'Pays institution expéditrice',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
MiscellaneousFormMeta.acquirerInstitutionCountry = {
  name: 'acquirerInstitutionCountry',
  type: 'text',
  label: ' Pays de l\'institution de l\'acquéreur',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}

// Institution Id
MiscellaneousFormMeta.receivingInstitutionId = {
  name: 'receivingInstitutionId',
  type: 'text',
  label: 'Id de l\'institution réceptrice',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
MiscellaneousFormMeta.settlementInstitutionId = {
  name: 'settlementInstitutionId',
  type: 'text',
  label: 'Id de l\'institution de règlement',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
MiscellaneousFormMeta.forwardingInstitutionId = {
  name: 'forwardingInstitutionId',
  type: 'text',
  label: 'Id de l\'institution expéditrice',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
MiscellaneousFormMeta.acquirerInstitutionId = {
  name: 'acquirerInstitutionId',
  type: 'text',
  label: 'Identifiant de l\'institution de l\'acquéreur',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}

// Others
MiscellaneousFormMeta.fieldNumber = {
  name: 'fieldNumber',
  type: 'text',
  label: 'Champ Numéro',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
MiscellaneousFormMeta.messageText = {
  name: 'messageText',
  type: 'text',
  label: 'Texte du message',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
MiscellaneousFormMeta.acquirerDate = {
  name: 'acquirerDate',
  type: 'text',
  label: 'Date de l\'acquéreur',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
MiscellaneousFormMeta.accountIdentification1 = {
  name: 'accountIdentification1',
  type: 'text',
  label: 'Identification du compte 1',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
MiscellaneousFormMeta.accountIdentification2 = {
  name: 'accountIdentification2',
  type: 'text',
  label: 'Identification du compte 2',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
MiscellaneousFormMeta.primaryRoutine = {
  name: 'primaryRoutine',
  type: 'text',
  label: 'Routine primaire',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
MiscellaneousFormMeta.secondaryRoutine = {
  name: 'secondaryRoutine',
  type: 'text',
  label: 'Routine secondaire',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}



MiscellaneousFormMeta.schema = yup.object().shape(getValidationSchema(MiscellaneousFormMeta));

export default MiscellaneousFormMeta;